var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumnSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10115",
    "data-name": "Group 10115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.206,
    height: 20,
    viewBox: "0 0 17.206 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 3,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right_2_",
    "data-name": "arrow-right (2)",
    transform: "translate(16.499 5.499) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x2: 10,
    transform: "translate(0 2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8797",
    "data-name": "Path 8797",
    d: "M0,0,2,2,0,4",
    transform: "translate(7.962)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9989",
    "data-name": "Group 9989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16889",
    "data-name": "Rectangle 16889",
    transform: "translate(10) rotate(90)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 9,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_30",
    "data-name": "Repeat Grid 30",
    transform: "translate(6.5 2.5) rotate(90)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1352 -269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16890",
    "data-name": "Rectangle 16890",
    transform: "translate(1352 269)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 2.5,
    height: 2.5,
    rx: 0.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1346 -269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16890-2",
    "data-name": "Rectangle 16890",
    transform: "translate(1352 269)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 2.5,
    height: 2.5,
    rx: 0.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1340 -269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16890-3",
    "data-name": "Rectangle 16890",
    transform: "translate(1352 269)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 2.5,
    height: 2.5,
    rx: 0.75,
    fill: "none"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnSel);
export default __webpack_public_path__ + "static/media/column_sel.0668e1d2.svg";
export { ForwardRef as ReactComponent };